import { generateEndpoint } from "@/utils/utils";
import type { PaginatedResponse } from "@/v2/queries/types";
import { apiClient } from "../apiClient";

export interface Transaction {
  id: string;
  userId: string;
  amount: number;
  currency: string;
  status: string;
  type: string;
  link?: string[];
  authorizedDate: string;
  capturedDate: string | null;
  description: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TransactionListParams {
  page?: number;
  search?: string;
  sort?: string;
  filter?: string;
  size?: number;
}

export interface CurrencyMapping {
  code: string;
  symbol: string;
  name: string;
}

export const getTransactions = (
  params: TransactionListParams = {}
): Promise<PaginatedResponse<Transaction>> => {
  const { page = 0, search = "", sort = "", filter = "", size = 10 } = params;
  const endpoint = generateEndpoint(
    `/payment-service/dashboard/payments?size=${size}`,
    page,
    search,
    sort,
    filter
  );
  return apiClient.get(endpoint).then((response) => response.data);
};

export const getTransactionById = (id: string): Promise<Transaction> => {
  return apiClient
    .get(`/payment-service/dashboard/payments/${id}`)
    .then((response) => response.data);
};

export const getCurrencyMappings = (): Promise<CurrencyMapping[]> => {
  return apiClient
    .get("/payment-service/dashboard/pricing/currencies")
    .then((response) => response.data);
};
